export { default as Cover } from './Cover';
export { default as MandatesCards } from './MandatesCards';
export { default as MandatesTable } from './MandatesTable';
export { IconStyled } from './Icon';
export { default as NewMandateForm } from './NewMandateForm';
